export enum HIGHLIGHT_COLOR_NAMES {
	DEFAULT = "default",
	PEONY = "peony",
	CINNAMON = "cinnamon",
	HONEY = "honey",
	MINT = "mint",
	TURQUOISE = "turquoise",
	MARINE = "marine",
	PLUME = "plume",
}

export const HIGHLIGHT_DOCX_NAMES: Record<Exclude<HIGHLIGHT_COLOR_NAMES, HIGHLIGHT_COLOR_NAMES.DEFAULT>, string> = {
	[HIGHLIGHT_COLOR_NAMES.PEONY]: "peony",
	[HIGHLIGHT_COLOR_NAMES.CINNAMON]: "green",
	[HIGHLIGHT_COLOR_NAMES.HONEY]: "magenta",
	[HIGHLIGHT_COLOR_NAMES.MINT]: "blue",
	[HIGHLIGHT_COLOR_NAMES.TURQUOISE]: "darkYellow",
	[HIGHLIGHT_COLOR_NAMES.MARINE]: "red",
	[HIGHLIGHT_COLOR_NAMES.PLUME]: "darkGray",
};
